import React from 'react';
import { useTranslation } from 'react-i18next';
import round from 'lodash/round';
import srmColorLookup from '../../../../../constants/srmColorLookup.json'
import { ebcToSrm } from '../../../../../components/forms/ColorPaletteInput/ColorPaletteInput';

interface PaletteFieldProps {
  value?: number;
  unit?: 'srm' | 'ebc';
}

const PaletteField = ({ value, unit = 'ebc' }: PaletteFieldProps) => {
  const [t] = useTranslation();

  const getRgbFromUnit = (color: number) => {
    const srm = unit === 'srm' ? color : ebcToSrm(color);
    const lookUp = srmColorLookup as Record<string, string>;
    return lookUp[String(round(srm, 1))] ?? lookUp[Math.round(srm).toString()];
  };

  if (value === undefined || value === null) return null;

  const rgb = getRgbFromUnit(value);

  return (
    <div className="w-full flex items-center justify-start py-2">
      <div className="flex items-center gap-2">
        <div className="text-primary-700 dark:text-primary-300 mr-2 text-sm font-medium">
          {t('global:shared.ColorInputSelectedLabel', 'Selected color:')}
        </div>
        <div
          className="border-primary-200 dark:border-primary-700 h-6 w-6 rounded-md border shadow-sm"
          style={{
            backgroundColor: rgb ? `rgb(${rgb})` : 'transparent',
          }}
        />
        <div className="text-primary-900 dark:text-primary-100 font-mono text-sm font-medium">
          {value} <span className="text-primary-500 dark:text-primary-400 ml-1 text-xs uppercase">{unit}</span>
        </div>
      </div>
    </div>
  );
};

export default PaletteField;
